function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.312,8.641C21.752,9.767 21.994,10.993 21.994,12.274C21.994,17.79 17.516,22.268 12,22.268C6.484,22.268 2.006,17.79 2.006,12.274C2.006,6.758 6.484,2.28 12,2.28C14.667,2.28 17.091,3.327 18.884,5.032M7.047,10.066L12,15.019L21.355,5.663",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.25px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.54118858eb71d79d0ade832e465ebde0.svg";
export { ForwardRef as ReactComponent };